import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from ".";

import { enumTypes } from "@configs";

interface IExternalType {
    type: enumTypes;
    id: string;
}
interface IPage {
    // navigationType: enumNavigation;
    showPopupHistory: boolean;
    trafficSourceId: string;
    isTrafficSourceExpired: boolean;
    inviteId: string;
    sellerId: string;
    couponId: string;
    freepointId: string;
    externalType: IExternalType | null;
    merchantId: string | null;
    cardDetail: {
        cNum: string;
        sNum: string;
    };
}

const initialState: IPage = {
    // navigationType: enumNavigation.USER_POINT,
    showPopupHistory: false,
    trafficSourceId: "",
    isTrafficSourceExpired: false,
    inviteId: "",
    sellerId: "",
    couponId: "",
    freepointId: "",
    externalType: null,
    merchantId: null,
    cardDetail: {
        cNum: "",
        sNum: "",
    },
};

const page = createSlice({
    name: "page",
    initialState,
    reducers: {
        setPopupHistory: (state, action: PayloadAction<boolean>) => {
            state.showPopupHistory = action.payload;
        },
        setTrafficId: (state, action: PayloadAction<string>) => {
            state.trafficSourceId = action.payload;
        },
        setTrafficSourceExpired: (state, action: PayloadAction<boolean>) => {
            state.isTrafficSourceExpired = action.payload;
        },
        setInviteId: (state, action: PayloadAction<string>) => {
            state.inviteId = action.payload;
            localStorage.setItem("inviteId", action.payload);
        },
        setSelelrId: (state, action: PayloadAction<string>) => {
            state.sellerId = action.payload;
            localStorage.setItem("sellerId", action.payload);
        },
        setCouponId: (state, action: PayloadAction<string>) => {
            state.couponId = action.payload;
            localStorage.setItem("couponId", action.payload);
        },
        setFreePointId: (state, action: PayloadAction<string>) => {
            state.freepointId = action.payload;
            localStorage.setItem("freepointId", action.payload);
        },
        setCardDetail: (state, action: PayloadAction<{ sNum: string; cNum: string }>) => {
            state.cardDetail = action.payload;
        },
        setExternalTypes: (state, action: PayloadAction<IExternalType | null>) => {
            state.externalType = action.payload;
        },
        setInitMerchantId: (state, action: PayloadAction<string>) => {
            state.merchantId = action.payload;
        },
    },
});

export const selectPage = (state: RootState) => state.page;

export const {
    // setNavigationType,
    setPopupHistory,
    setTrafficId,
    setTrafficSourceExpired,
    setInviteId,
    setSelelrId,
    setCouponId,
    setFreePointId,
    setCardDetail,
    setExternalTypes,
    setInitMerchantId,
} = page.actions;

export default page.reducer;
